import { Component, computed, effect, inject, input } from '@angular/core';
import { setTheme, Themes } from 'themes';
import { LandingpageConfigurationStateService } from 'app/shared/services/state/landingpage-configuration-state.service';
import { ContactComponent } from 'app/shared/components/contact';
import { HeaderComponent } from 'app/shared/components/header';
import { ImageMetadata } from 'app/shared/models/image-metadata.model';

@Component({
  selector: 'ez-main-layout',
  imports: [HeaderComponent, ContactComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  private readonly landingpageConfigurationStateService = inject(LandingpageConfigurationStateService);

  readonly assetStackBucketUrl = this.landingpageConfigurationStateService.assetStackBucketUrl;
  readonly organisation = this.landingpageConfigurationStateService.organisation;

  readonly theme = input<Themes>(Themes.WHITELABEL);
  readonly showWithdrawalLink = input<boolean>(false);

  readonly headerConfig = computed<ImageMetadata>(() => ({
    imgSrc: this.mainLogoUrl(),
    imgWidth: '250px',
    imgHeight: '100px',
  }));
  readonly mainLogoUrl = computed<string>(() => {
    const logos = this.organisation()?.corporateDesign.logos;
    return this.assetStackBucketUrl() && logos?.mainLogo
      ? this.assetStackBucketUrl() + logos.mainLogo
      : 'assets/icons/VR_Logo_RGB.png';
  });
  readonly smallLogoUrl = computed<string | undefined>(() => {
    const logos = this.organisation()?.corporateDesign.logos;
    return this.assetStackBucketUrl() && logos?.smallLogo ? this.assetStackBucketUrl() + logos.smallLogo : undefined;
  });

  readonly imprintUrl = computed(
    () =>
      this.organisation()?.web.imprintUrl ??
      'https://www.dzbank.de/content/dzbank/de/home/footer/rechtliche-hinweise/impressum.html',
  );
  readonly dataProtectionUrl = computed(
    () =>
      this.organisation()?.web.dataProtectionUrl ??
      'https://www.dzbank.de/content/dzbank/de/home/footer/rechtliche-hinweise/datenschutz.html',
  );
  readonly withdrawalUrl = computed(() => this.organisation()?.web.withdrawalUrl);

  constructor() {
    effect(() => {
      setTheme(this.theme());
    });
  }
}
